import {GetAllImpactSuccessEvent, ImpactStateEvent} from './state-event'
import {PriorityLevel} from '../priority'

export const impactStateReducer = (state: PriorityLevel[] = [], event: ImpactStateEvent<any> = { type: undefined, payload: undefined}) => {
    if (event.type === GetAllImpactSuccessEvent.type) {
        return event.payload || []
    } else {
        return state
    }
}
